import { render, staticRenderFns } from "./ModalTitle.vue?vue&type=template&id=bbb945b6&scoped=true&"
import script from "./ModalTitle.vue?vue&type=script&lang=js&"
export * from "./ModalTitle.vue?vue&type=script&lang=js&"
import style0 from "./ModalTitle.vue?vue&type=style&index=0&id=bbb945b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb945b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
